<template>
  <div>
    <Carousel />

    <MainPage @clickNew="scrollToBenefit" />

    <Benefit ref="refBenefit" id="benefit"/>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Carousel from "./Carousel.vue";
import MainPage from "./MainPage.vue";
import Header from "../commonComp/Header.vue"
import Benefit from "./Benefit.vue"

export default {
  components: {
    Header,
    Carousel,
    MainPage,
    Benefit,
  },
  data() {
    return {};
  },
  methods: {
    scrollToBenefit() {
      const scrollTarget = document.getElementById('benefit').offsetTop;
      window.scrollTo({ top: scrollTarget, behavior: "smooth" });
    }
  },
  computed: {
    accessInfo() {
      const CookieName = process.env.VUE_APP_CookieName;
      return JSON.parse(Cookies.get(CookieName));
    },
    ...mapGetters(["isAuthorized"]),
  },
};
</script>
<style lang="">
</style>